import { Selector } from '@ngxs/store';
import { EarningEventStateModel, FilterEarningEventState } from './earnings.state';

export class FilterEarningEventSelector {
  @Selector([FilterEarningEventState])
  static loading(state: EarningEventStateModel): boolean {
    return state.loading;
  }
  @Selector([FilterEarningEventState])
  static filterEarningEvent(state: EarningEventStateModel) {
    return state.paidEvent;
  }
  @Selector([FilterEarningEventState])
  static getDetailEarningEvent(state: EarningEventStateModel) {
    // null until an earning's detail is loaded, which is what the state says.
    return state.paidEventDetail?.event;
  }
  @Selector([FilterEarningEventState])
  static error(state: EarningEventStateModel) {
    return state.error;
  }
  @Selector([FilterEarningEventState])
  static paidEventKpis(state: EarningEventStateModel) {
    return state.kpis;
  }
  @Selector([FilterEarningEventState])
  static filter(state: EarningEventStateModel) {
    return state;
  }
}
